export var CountryEnum;
(function (CountryEnum) {
    CountryEnum[CountryEnum["Netherlands"] = 1] = "Netherlands";
    CountryEnum[CountryEnum["Germany"] = 2] = "Germany";
    CountryEnum[CountryEnum["Belgium"] = 3] = "Belgium";
    CountryEnum[CountryEnum["Sweden"] = 4] = "Sweden";
    CountryEnum[CountryEnum["Austria"] = 5] = "Austria";
    CountryEnum[CountryEnum["Switzerland"] = 6] = "Switzerland";
})(CountryEnum || (CountryEnum = {}));
